import { FiRrInfo } from '@app/assets';
import { Trans } from 'react-i18next';

export const BulkWarningBunner: React.FC = () => {
  return (
    <div className="flex gap-3 items-start rounded-lg bg-gray-100 border border-gray-300 px-3 py-2">
      <FiRrInfo className="text-gray-500 shrink-0" />
      <div className="flex flex-col gap-3">
        <p className="flex gap-1 flex-wrap text-xs text-gray-700">
          <Trans i18nKey={'qr.bulk.warningBanner'}>
            <b />
          </Trans>
        </p>
      </div>
    </div>
  );
};
